import React from "react";
import "./terms.css";

// Reusing the same logo import as the Terms page
import logo from "../../assets/images/RedP_LogoT.png";

const Privacy = () => {
  return (
    <div className="terms-page-container">
      <div className="split-view-card">
        {/* --- LEFT PANEL: Navigation & Metadata --- */}
        <div className="info-section">
          <div className="sticky-content">
            <img src={logo} alt="RedP Logo" className="sidebar-logo" />

            <h2>Privacy Policy</h2>

            <div className="meta-block">
              <p>
                <strong>Version:</strong> 1.0
              </p>
              <p>
                <strong>Effective Date:</strong> April 10, 2025
              </p>
            </div>

            {/* Navigation Links */}
            <div className="nav-links-container">
              <a href="https://www.waterviewai.com" className="nav-link">
                <span>←</span> Back to Sign In
              </a>

              {/* Link to the Terms page */}
              <a
                href="https://www.waterviewai.com/#/terms-and-conditions"
                className="nav-link"
              >
                Terms & Conditions <span>→</span>
              </a>
            </div>
          </div>
        </div>

        {/* --- RIGHT PANEL: Full Document --- */}
        <div className="document-section">
          <div className="document-header">
            <h1>RedP Privacy Policy</h1>
            <div className="subtitle">Real Estate Document Processor</div>
          </div>

          <div className="legal-content">
            <p>
              WaterviewAI (“we,” “our,” or “us”) respects your privacy and is
              committed to protecting your personal information. This Privacy
              Policy explains what data we collect, how we use it, and what your
              rights are when using RedP, our document processing tool.
            </p>

            <h4>1. Information We Collect</h4>
            <p>
              We collect only the minimum information necessary to operate the
              RedP platform:
            </p>
            <ol type="a">
              <li>
                <strong>User Account Information</strong>
                <ul>
                  <li>First Name</li>
                  <li>Last Name</li>
                  <li>Email Address</li>
                  <li>Password (securely hashed)</li>
                </ul>
              </li>
              <li>
                <strong>Customization Settings</strong>
                <ul>
                  <li>
                    Output preferences (e.g., formatting choices, templates)
                  </li>
                </ul>
              </li>
              <li>
                <strong>Session-Based Document Data</strong>
                <ul>
                  <li>
                    Any document content or text that you upload or input during
                    a session is processed temporarily and not stored after the
                    session ends.
                  </li>
                </ul>
              </li>
            </ol>
            <p>We do not collect or retain:</p>
            <ul>
              <li>Uploaded documents or extracted data (beyond session)</li>
            </ul>

            <h4>2. How We Use Your Information</h4>
            <p>We use your data to:</p>
            <ul>
              <li>Provide login access to RedP</li>
              <li>Customize the output experience based on your preferences</li>
              <li>Maintain system security and integrity</li>
              <li>
                Communicate with you about product updates, issues, or feedback
                requests
              </li>
            </ul>

            <h4>3. Data Retention and Deletion</h4>
            <ul>
              <li>
                Login data and preferences are retained until you delete your
                account.
              </li>
              <li>
                Document content and extracted data are processed in real-time
                and discarded once your session ends. This data is never stored
                or backed up.
              </li>
            </ul>
            <p>
              If you wish to delete your account or request removal of retained
              data, contact us at:{" "}
              <a href="mailto:RedP@WaterviewAI.com">RedP@WaterviewAI.com</a>
            </p>

            <h4>4. Data Security</h4>
            <p>
              We implement industry-standard practices to protect your data,
              including:
            </p>
            <ul>
              <li>Secure password hashing</li>
              <li>Encrypted communication via HTTPS</li>
              <li>Session-based isolation to prevent unauthorized access</li>
            </ul>
            <p>
              However, no system is entirely immune to breaches. You acknowledge
              and accept these risks by using RedP.
            </p>

            <h4>5. Third-Party Services</h4>
            <p>
              RedP does not share your information with third-party advertisers,
              data brokers, or analytics platforms. We may use third-party cloud
              infrastructure solely to host the application, in which case your
              data is processed within secure and reputable environments.
            </p>

            <h4>6. Children’s Privacy</h4>
            <p>
              RedP is intended for users aged 18 and older. We do not knowingly
              collect personal information from children. If you believe we have
              inadvertently collected data from a minor, please contact us to
              request deletion.
            </p>

            <h4>7. User Rights</h4>
            <p>You have the right to:</p>
            <ul>
              <li>Access your account data</li>
              <li>Correct inaccurate information</li>
              <li>Delete your account and associated data</li>
              <li>Stop using RedP at any time</li>
            </ul>
            <p>
              Please send any requests to:{" "}
              <a href="mailto:RedP@WaterviewAI.com">RedP@WaterviewAI.com</a>
            </p>

            <h4>8. Policy Updates</h4>
            <p>
              We may revise this Privacy Policy from time to time. Updates will
              be communicated via email or posted in-app. Continued use of RedP
              constitutes acceptance of any updated terms.
            </p>

            <h4>9. Contact Information</h4>
            <p>For privacy-related questions or concerns:</p>
            <p>
              Email:{" "}
              <a href="mailto:RedP@WaterviewAI.com">RedP@WaterviewAI.com</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
